function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "35.83 66.8 402.26 395.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7,400.79A18.42,18.42,0,1,1,253,375.16,18.43,18.43,0,0,1,257.7,400.79Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "437.59 94.81 423.46 232.69 414.77 317.51 293.33 305.07 269.7 302.65 254.57 301.1 267.98 170.2 277.39 78.4 437.59 94.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 318.7,
    cy: 156.65,
    r: 29.29,
    transform: "translate(-26.43 240.28) rotate(-39.8)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402,201.35l-3.32,7.52-89.2,118.94-9.93-6.34L313,304.55l80.12-100.5,7.07-4.49A2.53,2.53,0,0,1,402,201.35Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.57,292.59s-10,19.76-19.54,33.74l-6.84,1.77s-15.7,15.6-25.28,23.39a21.48,21.48,0,0,1-4.68-3.93s13.6-26.12,28.65-42.65a19,19,0,0,1,4.93,2.62,24.44,24.44,0,0,1,5.16,4.94l16.77-21.1Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "298.37 273.64 163.81 330.27 149.94 336.11 123.8 274 63.1 129.77 211.53 67.3 298.37 273.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7,400.79A18.42,18.42,0,1,1,253,375.16,18.43,18.43,0,0,1,257.7,400.79Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.3,399.13a15.5,15.5,0,1,1-3.94-21.57A15.51,15.51,0,0,1,255.3,399.13Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,399.13a15.5,15.5,0,1,1-3.94-21.57A15.51,15.51,0,0,1,255.3,399.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.52,382.57l.75-1.07,1.86,1.28-.75,1.08c1.39,1.45,1.36,3.26,0,5.22l-.32.46-2.15-1.49.42-.6c.71-1,.57-1.71-.15-2.21s-1.41-.4-2.13.64-.8,2-.11,4.32c.83,2.78.68,4.36-.46,6-1.36,2-3.08,2.64-4.92,1.86l-.73,1.05L236,397.84l.73-1.06c-1.41-1.46-1.36-3.29,0-5.26l.68-1,2.15,1.49-.78,1.13c-.72,1-.52,1.72.2,2.23s1.44.44,2.16-.6.81-2.06.11-4.32c-.85-2.75-.69-4.35.46-6C243,382.51,244.69,381.82,246.52,382.57Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.41,375.38a24.82,24.82,0,0,1-12.14,21.35,18.41,18.41,0,0,1,12-24.06A24.21,24.21,0,0,1,237.41,375.38Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,400.79A18.42,18.42,0,1,1,253,375.16,18.43,18.43,0,0,1,257.7,400.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.24,
    cy: 374.81,
    r: 18.43,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.24,
    cy: 374.81,
    r: 15.5,
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.24,
    cy: 374.81,
    r: 15.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,366.18v-1.3h2.26v1.3c2,.41,3,1.91,3,4.3V371h-2.62v-.73c0-1.26-.5-1.74-1.38-1.74s-1.38.48-1.38,1.74.5,2.13,2.36,3.62c2.26,1.81,3,3.19,3,5.2,0,2.39-1,3.93-3,4.33v1.28h-2.26v-1.28c-2-.4-3-1.94-3-4.33v-1.2h2.61v1.38c0,1.26.55,1.71,1.43,1.71s1.44-.45,1.44-1.71-.5-2.16-2.37-3.62c-2.26-1.79-3-3.19-3-5.21C212.19,368.12,213.17,366.61,215.11,366.18Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.15,
    cy: 380.36,
    r: 18.43,
    transform: "translate(-180.19 431.23) rotate(-57.35)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,369.81a15.5,15.5,0,1,1-21.9-.81A15.48,15.48,0,0,1,315.51,369.81Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,369.81a15.5,15.5,0,1,1-21.9-.81A15.48,15.48,0,0,1,315.51,369.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46,374.81l-.89-1,1.65-1.54.89,1c1.72-1,3.48-.62,5.1,1.13l.38.4-1.91,1.78-.5-.53c-.86-.92-1.55-.93-2.19-.33s-.69,1.29.16,2.21,1.83,1.22,4.2,1.05c2.89-.22,4.4.26,5.77,1.74,1.62,1.75,1.91,3.57.75,5.2l.87.94-1.66,1.54-.87-.94c-1.73,1.06-3.51.62-5.13-1.13l-.83-.88,1.92-1.78.94,1c.86.92,1.57.88,2.22.28s.74-1.31-.12-2.23-1.84-1.24-4.19-1c-2.88.23-4.41-.27-5.77-1.75C296.64,378.21,296.33,376.44,297.46,374.81Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.57,300.25s-.08,38.24,0,40.47,3,15.66,3,15.66l-9.29,17.12,8,6.44,15.55-15.28s13.24,8.17,15.66,19.87,16.83,20.22,31.78,52.62,32-72.49,32-72.49l-46.13-58.08Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.59 94.81 423.46 232.69 414.77 317.51 293.33 305.07 269.7 302.65 254.57 301.1 267.98 170.2 277.39 78.4 437.59 94.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.06,100l-69.15-7.09a2.36,2.36,0,1,0-.48,4.7l69.15,7.09a2.36,2.36,0,0,0,.48-4.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,107.85l-34.57-3.55a1.19,1.19,0,0,0-1.3,1.06,1.18,1.18,0,0,0,1.06,1.29l34.57,3.55a1.19,1.19,0,0,0,1.3-1.06A1.17,1.17,0,0,0,372.78,107.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.83,209.61l-112.24-11.5a1.18,1.18,0,0,0-1.3,1,1.19,1.19,0,0,0,1.06,1.3L410.59,212a1.18,1.18,0,0,0,1.29-1.06A1.17,1.17,0,0,0,410.83,209.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,218.06,279.45,204.69a1.17,1.17,0,0,0-1.29,1.05,1.18,1.18,0,0,0,1,1.3l130.51,13.37a1.18,1.18,0,1,0,.24-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,222.77l-94-9.63a1.18,1.18,0,0,0-.25,2.35l94,9.63a1.18,1.18,0,0,0,1.29-1.06A1.17,1.17,0,0,0,372.55,222.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.26,
    y: 181.5,
    width: 37.46,
    height: 132.26,
    transform: "translate(59.89 561.6) rotate(-84.15)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.7,
    cy: 156.65,
    r: 29.29,
    transform: "translate(-26.43 240.28) rotate(-39.8)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 318.7,
    cy: 156.65,
    r: 29.29,
    transform: "translate(-26.43 240.28) rotate(-39.8)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 318.7,
    cy: 156.65,
    r: 29.29,
    transform: "translate(-26.43 240.28) rotate(-39.8)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,156.56l24.36,12.25a28,28,0,0,0-3.22-29.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7,155.24l20.4-16.6a27.92,27.92,0,0,0-11.39-8.12L325,140.62Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,128.88,319.54,153l8.3-22.81A27.8,27.8,0,0,0,322,128.88Z",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,156.34l2.83-27.56a28,28,0,0,0-28.05,39Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.85,184.48a28,28,0,0,0,27.63-14.85l-24.79-12.47-25.27,11.48A28,28,0,0,0,315.85,184.48Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.49,
    y: 137.45,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(16.14 -36.36) rotate(5.85)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.13,144.08l-43.06-4.41a.53.53,0,0,1,.11-1L412.24,143a.53.53,0,0,1-.11,1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,145.94l-38.84-4a.53.53,0,0,1-.47-.58.52.52,0,0,1,.58-.47l38.84,4a.53.53,0,0,1-.11,1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.44,
    y: 147.72,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(17.18 -36.2) rotate(5.85)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,154.35,368,149.94a.53.53,0,0,1,.11-1.05l43.05,4.41a.54.54,0,0,1,.48.58A.53.53,0,0,1,411.08,154.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.62,156.22l-38.83-4a.53.53,0,1,1,.1-1.06l38.84,4a.53.53,0,1,1-.11,1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.39,
    y: 157.99,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(18.22 -36.03) rotate(5.85)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,164.63l-43-4.42a.53.53,0,1,1,.11-1.05l43.05,4.41a.53.53,0,0,1-.11,1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57,166.49l-38.84-4a.53.53,0,0,1-.47-.58.54.54,0,0,1,.58-.48l38.84,4a.53.53,0,0,1-.11,1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.33,
    y: 168.27,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(19.27 -35.87) rotate(5.85)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,174.9l-43.05-4.41a.53.53,0,0,1-.48-.58.54.54,0,0,1,.58-.48l43.06,4.42a.53.53,0,1,1-.11,1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.52,176.76l-38.84-4a.53.53,0,0,1,.11-1.05l38.84,4a.53.53,0,1,1-.11,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.28,
    y: 178.54,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(20.31 -35.71) rotate(5.85)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,185.17l-43.06-4.41a.53.53,0,0,1,.11-1L408,184.12a.53.53,0,1,1-.11,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.47,187l-38.84-4a.53.53,0,1,1,.11-1.05l38.83,4a.53.53,0,1,1-.1,1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.48,
    y: 246.45,
    width: 2.47,
    height: 14.13,
    transform: "translate(753.55 545.55) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.32,
    y: 251.79,
    width: 2.47,
    height: 6.65,
    transform: "translate(753.07 548.72) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.38,
    y: 243.47,
    width: 2.47,
    height: 14.13,
    transform: "translate(765.63 540.2) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.29,
    y: 249.32,
    width: 6.65,
    height: 2.47,
    transform: "translate(106.93 619.55) rotate(-84.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.64,
    y: 246.74,
    width: 2.47,
    height: 14.13,
    transform: "translate(775.78 547.24) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.8,
    y: 248.9,
    width: 2.47,
    height: 6.65,
    transform: "translate(776.26 544.13) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.23,
    y: 243.11,
    width: 2.47,
    height: 14.13,
    transform: "translate(743.42 538.35) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 248.45,
    width: 2.47,
    height: 6.65,
    transform: "translate(742.94 541.51) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.27,
    y: 246.7,
    width: 2.47,
    height: 14.13,
    transform: "translate(731.17 544.89) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.05,
    y: 252.57,
    width: 2.47,
    height: 6.65,
    transform: "translate(730.51 549.13) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.11,
    y: 242.5,
    width: 2.47,
    height: 14.13,
    transform: "translate(721.3 535.99) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.78,
    y: 249.43,
    width: 2.47,
    height: 6.65,
    transform: "translate(720.32 542.34) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.82,
    y: 249.29,
    width: 2.47,
    height: 14.13,
    transform: "translate(708.06 548.89) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.5,
    y: 256.21,
    width: 2.47,
    height: 6.65,
    transform: "translate(707.08 555.22) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 239.87,
    width: 2.47,
    height: 14.13,
    transform: "translate(699.8 529.62) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.03,
    y: 245.21,
    width: 2.47,
    height: 6.65,
    transform: "translate(699.31 532.8) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.75,
    y: 238.48,
    width: 2.47,
    height: 14.13,
    transform: "translate(689.06 526.31) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.91,
    y: 240.65,
    width: 2.47,
    height: 6.65,
    transform: "translate(689.55 523.17) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.31,
    y: 246.73,
    width: 2.47,
    height: 14.13,
    transform: "translate(675.39 542.11) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.52,
    y: 248.37,
    width: 2.47,
    height: 6.65,
    transform: "translate(676.03 537.93) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.41,
    y: 239.99,
    width: 2.47,
    height: 14.13,
    transform: "translate(666.3 528.15) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.3,
    y: 244.8,
    width: 2.47,
    height: 6.65,
    transform: "translate(665.97 530.28) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.5,
    y: 243.09,
    width: 2.47,
    height: 14.13,
    transform: "translate(654.18 533.75) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.33,
    y: 248.43,
    width: 2.47,
    height: 6.65,
    transform: "translate(653.7 536.91) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.32,
    y: 248.83,
    width: 2.47,
    height: 14.13,
    transform: "translate(641.27 544.57) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.93,
    y: 256.29,
    width: 2.47,
    height: 6.65,
    transform: "translate(640.14 551.94) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.69,
    y: 239.36,
    width: 2.47,
    height: 14.13,
    transform: "translate(633.02 525.2) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.48,
    y: 245.24,
    width: 2.47,
    height: 6.65,
    transform: "translate(632.37 529.43) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.79,
    y: 232.62,
    width: 2.47,
    height: 14.13,
    transform: "translate(623.92 511.26) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.57,
    y: 238.49,
    width: 2.47,
    height: 6.65,
    transform: "translate(623.28 515.48) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.5,
    y: 239.49,
    width: 2.47,
    height: 14.13,
    transform: "translate(610.67 524.32) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.66,
    y: 241.66,
    width: 2.47,
    height: 6.65,
    transform: "translate(611.15 521.21) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.15,
    y: 246.87,
    width: 2.47,
    height: 14.13,
    transform: "translate(597.26 538.39) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.42,
    y: 247.98,
    width: 2.47,
    height: 6.65,
    transform: "translate(598.06 533.16) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.43,
    y: 238.36,
    width: 2.47,
    height: 14.13,
    transform: "translate(588.71 520.93) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.26,
    y: 243.7,
    width: 2.47,
    height: 6.65,
    transform: "translate(588.21 524.12) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.13,
    y: 235.45,
    width: 2.47,
    height: 14.13,
    transform: "translate(578.44 514.6) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.35,
    y: 237.09,
    width: 2.47,
    height: 6.65,
    transform: "translate(579.09 510.42) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.15,
    y: 239.27,
    width: 2.47,
    height: 14.13,
    transform: "translate(566.11 521.61) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.77,
    y: 246.73,
    width: 2.47,
    height: 6.65,
    transform: "translate(564.98 528.98) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.07,
    y: 234.32,
    width: 2.47,
    height: 14.13,
    transform: "translate(556.48 511.2) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.79,
    y: 240.72,
    width: 2.47,
    height: 6.65,
    transform: "translate(555.66 516.49) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.34,
    y: 235.65,
    width: 2.47,
    height: 14.13,
    transform: "translate(544.92 513.27) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.01,
    y: 242.58,
    width: 2.47,
    height: 6.65,
    transform: "translate(543.94 519.6) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.99,
    y: 233.28,
    width: 2.47,
    height: 14.13,
    transform: "translate(534.49 507.99) rotate(-174.15)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.31,
    y: 233.85,
    width: 2.47,
    height: 6.65,
    transform: "translate(535.46 501.72) rotate(-174.15)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85,277.68,291.62,266.17a1.19,1.19,0,0,0-1.3,1.06,1.17,1.17,0,0,0,1.05,1.29L403.61,280a1.19,1.19,0,0,0,1.3-1.06A1.18,1.18,0,0,0,403.85,277.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,286.13,272.48,272.75a1.19,1.19,0,0,0-1.3,1.06,1.17,1.17,0,0,0,1.06,1.29l130.51,13.38a1.19,1.19,0,0,0,1.29-1.06A1.17,1.17,0,0,0,403,286.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,289l-75.69-7.76a1.19,1.19,0,0,0-1.3,1.06,1.18,1.18,0,0,0,1.06,1.29l75.69,7.76a1.18,1.18,0,1,0,.24-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.23,213.49c-3.87-.31-5.21,5.86-5.21,5.86s-6.12-8-5.15-26.88c0,0-3-8.36-11-3.31S378.56,212,380.54,231.4L365,179.71c-5.38,1.14-16.31,8.37-13.43,43.28l-17-18s-4.6-1.48-7.2,2.59-1.36,33.22.79,44.12-3.33,32.8-3.33,32.8-5.86-24.8-16.46-31.08L268,170.2,254.57,301.1l15.13,1.55L294,290.82c-.14,5.47-.27,10.5-.67,14.25l121.44,12.44,8.69-84.82C420.51,222.12,417.69,213.6,416.23,213.49Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "437.59 94.81 423.46 232.69 414.77 317.51 293.33 305.07 269.7 302.65 254.57 301.1 267.98 170.2 277.39 78.4 437.59 94.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.59,449.77l-71,12.08s-12.36-65.65-19.73-76-6-14.6-9.6-21.57c-2.16-4.21-13-12.06-21.49-19.81h0c-.74-.67-1.46-1.34-2.15-2-.3-.27-.58-.56-.86-.83-1.13-1.12-2.18-2.21-3.11-3.28q-.51-.57-1-1.14a16.2,16.2,0,0,1-3.44-6.09,1.55,1.55,0,0,1-.06-.31,2.58,2.58,0,0,1-.06-.37c-.19-1.55-.39-3.32-.59-5.24,0-.38-.08-.78-.13-1.18l-.06-.48c-.17-1.6-.36-3.3-.58-5.05s-.46-3.73-.74-5.64c-.09-.66-.18-1.32-.29-2,0,0,0,0,0,0-.11-.74-.23-1.48-.35-2.23L300,306.7c0-.11-.05-.21-.06-.3l-.42-2.22a1,1,0,0,1-.05-.25c-.14-.65-.27-1.29-.42-1.94-.31-1.45-.66-2.87-1-4.25a52.73,52.73,0,0,0-2.65-7.6c-5.12-11.43,1.54-7.3-2.47-36.71,0,0,2.95-6.82,11.36-1.37a22.53,22.53,0,0,1,1.88,1.37h0a23.64,23.64,0,0,1,4.47,4.78,27.62,27.62,0,0,1,3.86,8,34.61,34.61,0,0,1,1.14,14.3s6.32,21.66,9.65,26.59,17.1-23.39,16.21-26.69a44.59,44.59,0,0,1-.71-4.48c-.06-.49-.12-1-.19-1.56s-.13-1.12-.19-1.71c0-.28-.07-.58-.11-.87,0-.12,0-.24,0-.35-.12-1.13-.26-2.33-.39-3.57,0-.35-.07-.68-.11-1-.06-.59-.12-1.2-.18-1.8a2.53,2.53,0,0,1,0-.3c0-.34-.08-.69-.11-1-.08-.7-.15-1.41-.22-2.12s-.12-1.22-.18-1.83c-.12-1.15-.23-2.3-.34-3.41-.08-.83-.16-1.65-.23-2.45,0-.18,0-.36-.05-.53-.42-4.4-.75-8-.87-9.56,0,0-10-14.82-11-21.8s-.94-14.33,3.25-17.32c9.92-7.06,7,4.32,11.46,9s11.25,12.43,15.11,14.84c3.56,2.26,6.74,11,7.19,12.32-.51-1.92-5.6-20.8-5.71-24.6-.13-4-3.19-25.16,2-32.75s12.11-1.7,12.75-.2.83,22,2.66,27.7,9.49,29.47,9.49,29.47.32-23.12,2-33.47,6.22-18.44,10.62-18.9,8.47,4.39,8.47,4.39-1.74,16.5-1.24,20.31-.72,17.57,1.37,25c0,0-.24-19.71,2.82-22.23s5.69-3.73,7.41-2,2.09,13.37,3.84,20.39,1.53,16.56,2.68,27.51,5.68,26.15,4.78,34.84-3.67,30.24-5.9,42.89-7.92,30-7.92,30,2.59,9.25,2.09,17.5S435.59,449.77,435.59,449.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.24,211c1.36,4.22,5.91,18.34,8.17,25.39,0,0-9.92,7.29-9.68,14.07s-1.81,20.47-6.27,20.07-4-28.85-5.51-33.64c.91,2.06,1.49,3.73,1.61,4.06-.33-1.23-5.63-20.82-5.74-24.7,0-.91-.21-2.73-.42-5.08v0s9.87-9.45,17.11-3.67h0A26.37,26.37,0,0,0,375.24,211Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,219.12c-4.62,4.38-11.59,12.12-12.47,19.59,0,0,2.57,20.86,1.47,30l-9-28.21s.32-23.12,2-33.47c0-.28.1-.57.15-.85A41.13,41.13,0,0,1,405,201.71a79.7,79.7,0,0,0-.39,11.07A60.38,60.38,0,0,1,404.73,219.12Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,215.52h0l0,0c-.11.07-.38.29-.77.62a11.77,11.77,0,0,1,.78-1.3Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,273.19s-5.94-22.28-6-40.22c-.05-6.64.72-12.69,2.87-16.78h0a11.77,11.77,0,0,1,.78-1.3l0,.64a16.65,16.65,0,0,1,3.54-2.34c-1.67,2.6-3.59,7.69-1.37,16C414.48,242.1,411.44,257.93,411.17,273.19Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.24,315.65s1.59,21.23-15.47,28.83h0c-.74-.67-1.46-1.34-2.15-2-.3-.27-.58-.56-.86-.83-1.13-1.12-2.18-2.21-3.11-3.28-.35-.39-.66-.77-1-1.14a16.2,16.2,0,0,1-3.44-6.09,1.55,1.55,0,0,1-.06-.31,2.58,2.58,0,0,1-.06-.37c-.19-1.55-.39-3.32-.59-5.24,0-.38-.08-.78-.13-1.18l-.06-.48c-.17-1.6-.36-3.3-.58-5.05s-.46-3.73-.74-5.64c-.1-.66-.19-1.33-.29-2,0,0,0,0,0,0-.11-.74-.23-1.48-.35-2.23L300,306.7c0-.11-.05-.21-.06-.3l-.42-2.22a1,1,0,0,1-.05-.25c-.14-.65-.27-1.29-.42-1.94-.32-1.44-.67-2.86-1-4.25,6.75-6.49,22.33-2.42,14.79-17.47,0,0,3.8-12.88-6.67-26.84h0c7.16,5.77,10.83,15.92,9.47,27,0,0,6.32,21.66,9.65,26.59s17.1-23.39,16.21-26.69a44.59,44.59,0,0,1-.71-4.48c-.06-.49-.12-1-.19-1.56s-.13-1.12-.19-1.71c0-.28-.07-.58-.11-.87,0-.12,0-.24,0-.35q-.18-1.71-.39-3.57c0-.35-.07-.68-.11-1-.06-.59-.12-1.2-.18-1.8a2.53,2.53,0,0,1,0-.3c0-.34-.08-.69-.11-1-.08-.7-.15-1.41-.22-2.12s-.12-1.22-.18-1.83c-.12-1.15-.23-2.3-.34-3.41-.08-.83-.15-1.66-.23-2.45,0-.18,0-.36-.05-.53.27,1.31,5.34,25.45,8.24,31.07C349.64,290.18,337,320.65,329.24,315.65Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.63,339.12c-2.23,12.66-7.92,30-7.92,30s2.59,9.25,2.09,17.5c-.14,2.22,1.24,7.83,3.3,14.83-.6-1.54-7-18.06-6.87-23.82.13-6.05-1.59-7.72-5-15.15s-8.51-6.61-8.51-6.61-2,18.53-6.64,6.35-5.55-26.35,6.18-75.55c0,0,1.77,6.17.29,24.5s2.9,23.88,2.9,23.88a171.23,171.23,0,0,0,15.59-36.35s-1.52,21.39-2.87,31.13,4.81-11.29,9.11-24.28c4-12.19,4.19-16.83,2.65-25.51,1.14,6.11,2,12,1.56,16.21C426.63,304.9,423.86,326.47,421.63,339.12Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,380.36c3.46,5.5,11.93,12.77,17,32.88s1.87,42.12,1.87,42.12Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.51,266.17s-17.71,9-19.11,24c-5.12-11.43,1.54-7.3-2.47-36.71,0,0,2.95-6.82,11.36-1.37a22.53,22.53,0,0,1,1.88,1.37h0a23.64,23.64,0,0,1,4.47,4.78Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,461.85s-12.36-65.65-19.73-76-6-14.6-9.6-21.57-30.93-23.93-32.14-33.84-2.6-28.87-7.72-40.31,1.54-7.3-2.48-36.71c0,0,3-6.82,11.37-1.37s12.83,16.35,11.36,28.42c0,0,6.32,21.64,9.66,26.58s17.08-23.39,16.19-26.7-3.53-31.46-3.94-36.6c0,0-10-14.83-11-21.81s-.94-14.33,3.25-17.31c9.92-7.06,7,4.32,11.46,9s11.25,12.42,15.1,14.84S363.58,241,363.58,241s-5.65-20.74-5.76-24.75-3.19-25.16,2-32.74,12.12-1.71,12.76-.21.83,22,2.67,27.7l9.47,29.47s.33-23.12,2.06-33.47,6.22-18.44,10.62-18.9,8.47,4.39,8.47,4.39-1.74,16.5-1.25,20.31-.71,17.56,1.38,25c0,0-.24-19.71,2.82-22.23s5.69-3.73,7.41-2,2.09,13.37,3.84,20.39,1.53,16.56,2.68,27.51,5.68,26.15,4.78,34.83-3.67,30.25-5.91,42.91-7.9,30-7.9,30,2.58,9.25,2.08,17.5,19.78,63.17,19.78,63.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,240.45c2.07,4.86,7.18,25.38,9,28.22a9.74,9.74,0,0,0,3.9,3.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,237.75s-.44,4.21,1.83,17.61,3.38,19.11,4.65,22.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,241c2.77,8.17,4.34,21.19,5.92,25.11s3,4.73,3,4.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,260.58a12.43,12.43,0,0,1,3.84,4.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,307.06s1.51,10.83,8.3,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,280.36s1.76,12.88-1.12,18.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,280.48s4.56,2.79,1.51,11-8.36,41.23-8.36,41.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,289.12c1.91,7.4,2.08,7.59-1,16.68s-8.11,31.36-8.11,31.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72,369.1s-3-6-.52-11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,385.86s7.54,10.59,10.82,22.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.34 200.23 402.38 198.22 403.3 197.95 403.24 198.95 401.37 201.34 400.34 200.23",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,201.35l-3.32,7.52-89.2,118.94-9.93-6.34L313,304.55l80.12-100.5,7.07-4.49A2.53,2.53,0,0,1,402,201.35Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402,201.35l-3.32,7.52-89.2,118.94-9.93-6.34L313,304.55c6.2-.64,7.24,3,7.24,3l76.85-100.3c-.76-2.7-4-3.22-4-3.22l7.07-4.49A2.53,2.53,0,0,1,402,201.35Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402,201.35l-3.32,7.52-89.2,118.94-9.93-6.34L313,304.55l80.12-100.5,7.07-4.49A2.53,2.53,0,0,1,402,201.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.57,292.59s-10,19.76-19.54,33.74l-6.84,1.77s-15.7,15.6-25.28,23.39a21.48,21.48,0,0,1-4.68-3.93s13.6-26.12,28.65-42.65a19,19,0,0,1,4.93,2.62,24.44,24.44,0,0,1,5.16,4.94l16.77-21.1Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.57,292.59s-10,19.76-19.54,33.74l-6.84,1.77s-15.7,15.6-25.28,23.39l.26-4.24c10.39-15.87,23.59-33.18,28.64-39.72a24.44,24.44,0,0,1,5.16,4.94l-9.32,12.44,5.34-1,20.75-32.58Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.57,292.59s-10,19.76-19.54,33.74l-6.84,1.77s-15.7,15.6-25.28,23.39a21.48,21.48,0,0,1-4.68-3.93s13.6-26.12,28.65-42.65a19,19,0,0,1,4.93,2.62,24.44,24.44,0,0,1,5.16,4.94l16.77-21.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.48,270.82l-27.86,27-4.45,4.32c3.05-7.84,1.57-20,1.38-21.43v0c0-.08,0-.13,0-.13s0-.16,0-.21a44.59,44.59,0,0,1-.71-4.48c-.06-.49-.12-1-.19-1.56s-.13-1.12-.19-1.71c0-.28-.07-.58-.11-.87,0-.12,0-.24,0-.35-.12-1.13-.26-2.33-.39-3.57,0-.35-.07-.68-.11-1-.06-.59-.12-1.2-.18-1.8a2.53,2.53,0,0,1,0-.3c0-.34-.08-.69-.11-1-.08-.7-.15-1.41-.22-2.12s-.12-1.22-.18-1.83c-.12-1.15-.23-2.3-.34-3.41-.08-.83-.16-1.65-.23-2.45,0-.18,0-.36-.05-.53-.42-4.4-.75-8-.87-9.56,0,0-10-14.82-11-21.8s-.94-14.33,3.25-17.32c9.92-7.06,7,4.32,11.46,9s11.25,12.43,15.11,14.84S363.58,241,363.58,241c2.77,8.16,4.34,21.18,5.92,25.1S372.48,270.82,372.48,270.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,260.58a12.43,12.43,0,0,1,3.84,4.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23,213.67c4.42,4.72,11.21,12.38,15.07,14.82-.54-.27-7.65-3.73-11.62.12-4.13,4-7.12,15.15-7.12,15.15s-10-14.82-11-21.8-.94-14.33,3.25-17.32C339.69,197.58,336.79,209,341.23,213.67Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62,297.84l-4.45,4.32c3.05-7.84,1.57-20,1.38-21.43v0a1.51,1.51,0,0,0,0-.34,44.59,44.59,0,0,1-.71-4.48c-.06-.49-.12-1-.19-1.56s-.13-1.12-.19-1.71c0-.28-.07-.58-.11-.87,0-.12,0-.24,0-.35q-.18-1.71-.39-3.57c0-.35-.07-.68-.11-1-.06-.59-.12-1.2-.18-1.8a2.53,2.53,0,0,1,0-.3c0-.34-.08-.69-.11-1-.08-.7-.15-1.41-.22-2.12s-.12-1.22-.18-1.83c-.12-1.15-.23-2.3-.34-3.41-.08-.83-.15-1.66-.23-2.45,0-.18,0-.36-.05-.53.27,1.31,5.34,25.45,8.24,31.07C347.76,286.52,346.74,292,344.62,297.84Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,270.82s-1.41-.81-3-4.73-3.15-16.94-5.92-25.11c0,0-3.39-10-7.25-12.46s-10.66-10.12-15.1-14.84-1.54-16.1-11.46-9c-4.19,3-4.28,10.34-3.25,17.31s11,21.81,11,21.81c.41,5.14,3.05,33.3,3.94,36.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,280.36s1.76,12.88-1.12,18.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.47,296.11s6.33,29.4-7.38,50.78-24.27,27.09-29,33.47-23.32,42.05-23.32,42.05l-21.7-64.27,21.7-79.51Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.37 273.64 163.81 330.27 149.94 336.11 123.8 274 63.1 129.77 211.53 67.3 298.37 273.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.18,94.15l-64.07,27a2.36,2.36,0,0,0,1.83,4.36L175,98.5a2.36,2.36,0,1,0-1.83-4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.93,109.84l-32,13.48a1.18,1.18,0,0,0,.92,2.18l32-13.49a1.18,1.18,0,1,0-.92-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.64,192s1.35,10.61-2.6,12.27c-3.61,1.52-8.36-4.17-12.51-2.43s-.88,16.8-4.88,18.48-8.82-4.5-12.28-3-1.36,9.2-4.92,10.7c-2.94,1.23-7.14-4.92-10.5-6.27a2.55,2.55,0,0,0-2-.1c-3.52,1.48-1.77,17.65-4.81,18.92a5.72,5.72,0,0,1-2.7.45,19.06,19.06,0,0,0-3.43-.33,4.4,4.4,0,0,0-1.28.33c-2.59,1.09-2.24,9.6-4.61,10.6s-4.71-.24-7.24.82-2.49,5.49-6.27,7.08l1.6,3.79,92.11-38.76",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.56 218.92 135.21 263.23 231.65 222.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.05,209.58s-.46-.56-1.14-1.23c-1.19-1.15-3.08-2.61-4.52-2s-1.53,2.92-1.5,5.42c0,3,.3,6.3-1.23,6.94-1.3.55-2.46-.27-3.66-1.17-1.37-1-2.77-2.14-4.46-1.43-2.84,1.2-2,4.9-3,8.07a6.13,6.13,0,0,1-3.75,4c-2.45,1-4.94,0-7.29-1.58-4-2.7-7.52-7.08-9.82-6.11-3.67,1.55.37,11.47-3.57,13.13-2.2.93-6.76-6-11.19-12-3.5-4.73-6.92-8.85-9-8-4.75,2,3.08,25.73-.37,27.18l-.11.05a3.68,3.68,0,0,1-3.43-.33c-1.24-.7-2.26-1.71-3.63-1.13-2.55,1.08-1.06,10.38-3.86,11.56s-4.49-.53-7.65.8c-2.67,1.13-4.26,7.6-4.26,7.6l1.6,3.79,92.11-38.76",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.55,241.21l-32,13.48a1.18,1.18,0,0,0,.92,2.18l32-13.48a1.18,1.18,0,0,0-.92-2.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.97,
    y: 188.59,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(-56.33 102.72) rotate(-22.82)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,182.9l-12.8,5.39a.55.55,0,0,1-.7-.29.53.53,0,0,1,.28-.69l12.81-5.39a.53.53,0,0,1,.69.28A.53.53,0,0,1,243.67,182.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.66,186.67l-8.9,3.74a.53.53,0,0,1-.69-.28.53.53,0,0,1,.28-.7l8.9-3.74a.53.53,0,0,1,.69.28A.54.54,0,0,1,240.66,186.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.98,
    y: 198.11,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(-59.71 105.02) rotate(-22.82)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,192.42l-12.8,5.38a.53.53,0,0,1-.41-1l12.8-5.39a.53.53,0,1,1,.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66,196.18l-8.89,3.75a.53.53,0,0,1-.42-1l8.9-3.74a.53.53,0,1,1,.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,231.66l-104,43.76a1.18,1.18,0,0,0,.92,2.18l104-43.77a1.18,1.18,0,1,0-.92-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,239.49,146.88,290.38a1.18,1.18,0,1,0,.92,2.17l120.92-50.89a1.18,1.18,0,1,0-.91-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,247.32,150.18,298.21a1.18,1.18,0,1,0,.92,2.17L272,249.49a1.18,1.18,0,1,0-.92-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4,255.15,153.48,306a1.18,1.18,0,1,0,.91,2.17l120.92-50.89a1.18,1.18,0,1,0-.91-2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,284.35l-70.13,29.52a1.18,1.18,0,1,0,.92,2.17l70.13-29.51a1.18,1.18,0,1,0-.92-2.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28,131.7s1.35,10.62-2.6,12.28c-3.61,1.52-8.37-4.17-12.51-2.43s-.88,16.79-4.88,18.48-8.83-4.5-12.28-3.05-1.36,9.2-4.92,10.69c-2.94,1.24-7.14-4.91-10.5-6.26a2.55,2.55,0,0,0-2-.1c-3.52,1.48-1.77,17.64-4.81,18.92a5.58,5.58,0,0,1-2.7.44,20.18,20.18,0,0,0-3.43-.32,4.32,4.32,0,0,0-1.28.33c-2.59,1.09-2.24,9.6-4.61,10.59s-4.71-.23-7.24.83-2.49,5.49-6.27,7.08l1.6,3.79L202,164.21",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,145.85s.84,5.14-1.19,6c-1.69.71-2.73-.28-4.51-.34A5.86,5.86,0,0,0,186,152c-1.63.68-2,2.88-2.31,5.24-.36,2.91-.54,6.07-2.67,7-1.49.63-3.1.26-4.76-.32-2.65-.92-5.43-2.38-8.12-1.25-1.3.55-2.21,2-2.92,3.71-1.67,4.13-2.19,10.11-4,10.87-2.57,1.09-7.28-3.33-9.56-2.37s-1.35,4.92-3.2,5.7-2.91-1.52-6.17-.15-1.67,6.19-6.27,8.13-6.62-1.63-11.06.24-3.64,5.25-6.78,6.57-4.46-1-6.7,0-2.78,4.49-2.81,4.71l1.23,2.92L202,164.21",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "91.2 158.66 109.85 202.97 206.28 162.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,180.26l-32,13.48a1.18,1.18,0,0,0,.91,2.18l32-13.48a1.18,1.18,0,0,0-.92-2.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.99,
    y: 124.48,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(-33.58 87.24) rotate(-22.82)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.69,118.79l-12.8,5.39a.55.55,0,0,1-.7-.29.53.53,0,0,1,.29-.69l12.8-5.39a.53.53,0,0,1,.69.29A.52.52,0,0,1,216.69,118.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68,122.56l-8.9,3.74a.53.53,0,0,1-.41-1l8.9-3.75a.53.53,0,0,1,.69.28A.54.54,0,0,1,213.68,122.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 134,
    width: 4.61,
    height: 4.61,
    rx: 0.63,
    transform: "translate(-36.95 89.54) rotate(-22.82)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.69,128.31l-12.8,5.39a.53.53,0,0,1-.69-.29.52.52,0,0,1,.28-.69l12.8-5.39a.53.53,0,1,1,.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,132.08l-8.89,3.74a.53.53,0,1,1-.42-1l8.9-3.74a.53.53,0,1,1,.41,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.81,330.27l-13.87,5.84L123.8,274a15.39,15.39,0,0,0,4.37-8.57c1.56-8.32.46-35.07,21.29-37.83s3.26,44.08,4.22,53C154.56,288.74,166.43,312.37,163.81,330.27Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.37 273.64 163.81 330.27 149.94 336.11 123.8 274 63.1 129.77 211.53 67.3 298.37 273.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,284c2.34-8,11.46-33.62,10.26-44.95a11.39,11.39,0,0,0-.64-2.76c-3.2-8.46-16.28-7.64-21.31-.63-5.51,7.71-10,21.59-10.4,30a26.15,26.15,0,0,1-4,11.86l0,0a29.93,29.93,0,0,1-2.65,3.76L96.87,210.53a40.35,40.35,0,0,0-7.81,8.71,14.42,14.42,0,0,0-2.3,6.07C86.15,232.29,78.25,261,75,273c-.07.26-.14.51-.2.75-3.16,11.62,5.18,54.78,2.79,67.32s-3.86,12.25-4.21,21.16c-.25,6.5-9.55,26.26-20,46.55-6,11.63-12.32,23.41-17.55,33l76.32-3.17c1.32-9.27,2.68-19.06,3.92-28.54a105.72,105.72,0,0,1,2.28-11.71h0c1.68-6.8,3.73-12.95,5-16.55a153.76,153.76,0,0,0,4-16.09c8.88-9.4,20.52-24.17,23.89-34.17l0-.07A12.44,12.44,0,0,0,152,325a29.65,29.65,0,0,1-.61-5.46s0,0,0,0C151,308.68,153.47,290.65,155.43,284Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,277.59c-2.37,4.75-5.22,9.36-7,14.68s-3.77,6.08-9.11,10.25-9.24-2.7-9.24-2.7,7.07-7.34,4.72-11.43-11.15-14.26-10.63-19.87-5.33-18.19-5.33-18.19,13.33-7.83,10.74-17c-1.41-5-8.39-10.33-14.41-14.12a40.35,40.35,0,0,1,7.81-8.71l29.84,70.82A29.93,29.93,0,0,0,129.36,277.59Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,321c.18.6,4.52,14.93.86,20.9s-7.42,13.89-5.63,22c1.42,6.48-10.58,29.88-22.81,44.9,10.42-20.29,19.72-40.05,20-46.55.35-8.91,1.82-8.64,4.21-21.16s-6-55.7-2.79-67.32c.06-.24.13-.49.2-.75,2.33,13.17,7.75,39.4,9.24,47.83C86.11,331.61,81.16,321.45,81,321Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44,407.5c8.87-38.19,38.72-67.47,42.76-75.95-3.37,10-15,24.77-23.89,34.17a153.76,153.76,0,0,1-4,16.09c-1.25,3.6-3.3,9.75-5,16.55h0C109.68,408.59,108.44,407.5,108.44,407.5Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,284c-2,6.65-4.43,24.68-4.05,35.51-1.57-6.8-4.59-15.44-5.09-27.47C145.44,271.64,157,279,153,268.91s-15.52,2.83-9.86-18.44c4.13-15.53,15.9-15.39,21.94-14.18a11.39,11.39,0,0,1,.64,2.76C166.89,250.38,157.77,276,155.43,284Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44,420.73C57,403.24,66.31,385.25,73,365.85c.8-2.79-.27-6.43.54-9.22,9.06-25.19-1.22-51.42.47-77.23C75.44,269.23,78.69,259,82,248.73c1.53-7.41,2.1-15.71,4.55-23.17,2.52-5.62,5-12.15,10.37-15,10.2,23.37,20.36,46.85,29.84,70.82,4.29-2.48,5-8,5.7-12.65,2.3-11.13,4.63-21.33,8.84-30.7,4.28-7.53,15.18-10.74,21.87-4.59a10.48,10.48,0,0,1,3.06,7.23c-1.3,12.92-5.36,26-9.45,38.08-1.61,5.58-3.25,10.25-3.94,15.79.07,1.84.11,2.75.19,4.59-2.37,9.29-.19,17.47-.73,26.69-2.07,16.63-15.38,28.21-25,40.56-2.38,9.29-4.75,18.58-8,27.91-4,14-5.28,27.8-6.65,41.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72,281.35a61.91,61.91,0,0,0-4.4,10.92c-1.25,4.9-7.58,4.2-10.85,7.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.84,272.72s8.61,3,13.63,6.95,8.72,4.87,8.72,4.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.35,251.37s7,1.95,12.1-.5a45.57,45.57,0,0,1,1.31-7.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,251.88s.07,1,3.61,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.31,365.72A47.46,47.46,0,0,0,116.39,383",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.36,275.92c-.32,6,6.72,27.28,8.85,37.86s2.94,18.06,2.94,18.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.efd28ded910f18e5b017bd09d7fb60c7.svg";
export { ForwardRef as ReactComponent };